import { useEffect, useState } from 'react';

type UseLocalSearchProps = {
  initialValuesLoad: any;
}

type Values = {
  label: string;
  value: string;
}

const useLocalSearch = ({ initialValuesLoad }: UseLocalSearchProps) => {
  const [ initialValues, setInitialValues ] = useState<Values[] | null>(null);
  const [ filteredValues, setFilteredValues ] = useState<Values[] | null>(null);

  useEffect(() => {
    const loadInitialValues = async () => {
      const values = await initialValuesLoad().unwrap();
      const mapped = values.map((item: any) => ({
        label: item,
        value: item
      }));
      setInitialValues(mapped);
      setFilteredValues(mapped);
    };
    loadInitialValues();
  }, []);

  const filter = (term: string) => {
    if (!term) {
      setFilteredValues(initialValues);
    } else {
      const lowerTerm = term.toLowerCase().trim();
      const filtered = initialValues?.filter(item => item.label.toLowerCase().includes(lowerTerm)) || null;
      setFilteredValues(filtered);
    }
  };


  return { filteredValues, filter };
};

export { useLocalSearch };